import {
  setFetchMessage,
  setLoadingStatus,
  unsetLoadingStatus,
} from "store/helper/actions";
import { SET_CLIENTS_LIST } from "store/client/types";

import * as api from "lib/api";
import API_RESOURCES from "lib/api/resources";

export const setClientsList = (clientsList) => ({
  type: SET_CLIENTS_LIST,
  payload: {
    clientsList,
  },
});

export const fetchClientsList = () => {
  return async (dispatch) => {
    dispatch(setLoadingStatus());
    dispatch(setClientsList([]));

    try {
      const response = await api.get(API_RESOURCES.CLIENTS);

      if (response) {
        dispatch(setClientsList(response.data));
      }
    } catch (e) {
      dispatch(setFetchMessage(e));
    } finally {
      dispatch(unsetLoadingStatus());
    }
  };
};

/**
 * Action to create / edit clients
 *
 * @param clientPayload
 * @param clientId
 * @param shouldUpdate
 * @returns {function(*): Promise<*>}
 */
export const saveClient = (clientPayload, clientId, shouldUpdate = true) => {
  return async (dispatch) => {
    try {
      let response;

      if (clientId) {
        response = await api.put(
          `${API_RESOURCES.CLIENTS}/${clientId}`,
          clientPayload
        );
      } else {
        response = await api.post(API_RESOURCES.CLIENTS, clientPayload);
      }

      if (response) {
        dispatch(setFetchMessage({ ...response, shouldUpdate }));
      }
    } catch (e) {
      dispatch(setFetchMessage(e));
    }
  };
};

